/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {WorkTimeComponent as Éµa} from './src/app/modules/work-time/work-time.component';